module.exports = __webpack_public_path__ + "img/seat-4.1d5b0d74.jpg";